// extracted by mini-css-extract-plugin
export default {"textTooltip":"BimWorkOrderPriceCounter_textTooltip__rUowx","delimiter":"BimWorkOrderPriceCounter_delimiter__KI8vM"};